/* eslint-disable @typescript-eslint/no-empty-function */

import $ from 'jquery';
import _ from 'lodash';

import { Thunk } from '../thunk';

let isMonitoringWindowResize = false;
export function monitorWindowSize(): Thunk {
  if (isMonitoringWindowResize) {
    return () => {};
  }
  isMonitoringWindowResize = true;
  return (dispatch) => {
    const $window = $(window);
    const dispatchUpdateWindowSize = (): void => {
      dispatch({
        type: 'UPDATE_WINDOW_SIZE',
        size: {
          // pretty sure the window always has a width/height
          width: $window.width() as number,
          height: $window.height() as number,
          outerWidth:
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth,
          outerHeight:
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight,
        },
      });
    };
    dispatchUpdateWindowSize();
    $window.on(
      'resize orientationchange',
      _.debounce(dispatchUpdateWindowSize, 200)
    );
  };
}
